{
    "nm": "Main Scene",
    "ddd": 0,
    "h": 1080,
    "w": 1920,
    "meta": { "g": "@lottiefiles/creator 1.37.1" },
    "layers": [
        {
            "ty": 4,
            "nm": "Dot4",
            "sr": 1,
            "st": 0,
            "op": 360,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [-284, 92, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [50, 50],
                            "t": 25
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [75, 75],
                            "t": 39
                        },
                        { "s": [50, 50], "t": 55 }
                    ],
                    "ix": 6
                },
                "sk": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [1142, 540],
                            "t": 25
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [1142, 500],
                            "t": 39
                        },
                        { "s": [1142, 540], "t": 55 }
                    ],
                    "ix": 2
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [25],
                            "t": 25
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [100],
                            "t": 39
                        },
                        { "s": [25], "t": 55 }
                    ],
                    "ix": 11
                }
            },
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Ellipse 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 3,
                    "it": [
                        {
                            "ty": "el",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Ellipse",
                            "nm": "Ellipse Path 1",
                            "d": 1,
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "s": { "a": 0, "k": [120, 120], "ix": 2 }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": { "a": 0, "k": [0.0902, 0.6784, 0.5255], "ix": 4 },
                            "r": 1,
                            "o": { "a": 0, "k": 100, "ix": 5 }
                        },
                        {
                            "ty": "tr",
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "p": { "a": 0, "k": [-284, 92], "ix": 2 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "o": { "a": 0, "k": 100, "ix": 7 }
                        }
                    ]
                }
            ],
            "ind": 1
        },
        {
            "ty": 4,
            "nm": "Dot3",
            "sr": 1,
            "st": 0,
            "op": 360,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [-284, 92, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [50, 50],
                            "t": 17
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [75, 75],
                            "t": 31
                        },
                        { "s": [50, 50], "t": 47 }
                    ],
                    "ix": 6
                },
                "sk": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [1022, 540],
                            "t": 17
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [1022, 500],
                            "t": 31
                        },
                        { "s": [1022, 540], "t": 47 }
                    ],
                    "ix": 2
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [25],
                            "t": 17
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [100],
                            "t": 31
                        },
                        { "s": [25], "t": 47 }
                    ],
                    "ix": 11
                }
            },
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Ellipse 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 3,
                    "it": [
                        {
                            "ty": "el",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Ellipse",
                            "nm": "Ellipse Path 1",
                            "d": 1,
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "s": { "a": 0, "k": [120, 120], "ix": 2 }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": { "a": 0, "k": [0.0902, 0.6784, 0.5255], "ix": 4 },
                            "r": 1,
                            "o": { "a": 0, "k": 100, "ix": 5 }
                        },
                        {
                            "ty": "tr",
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "p": { "a": 0, "k": [-284, 92], "ix": 2 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "o": { "a": 0, "k": 100, "ix": 7 }
                        }
                    ]
                }
            ],
            "ind": 2
        },
        {
            "ty": 4,
            "nm": "Dot2",
            "sr": 1,
            "st": 0,
            "op": 360,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [-284, 92, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [50, 50],
                            "t": 9
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [75, 75],
                            "t": 23
                        },
                        { "s": [50, 50], "t": 39 }
                    ],
                    "ix": 6
                },
                "sk": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [902, 540],
                            "t": 9
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [902, 500],
                            "t": 23
                        },
                        { "s": [902, 540], "t": 39 }
                    ],
                    "ix": 2
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [25],
                            "t": 9
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [100],
                            "t": 23
                        },
                        { "s": [25], "t": 39 }
                    ],
                    "ix": 11
                }
            },
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Ellipse 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 3,
                    "it": [
                        {
                            "ty": "el",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Ellipse",
                            "nm": "Ellipse Path 1",
                            "d": 1,
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "s": { "a": 0, "k": [120, 120], "ix": 2 }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": { "a": 0, "k": [0.0902, 0.6784, 0.5255], "ix": 4 },
                            "r": 1,
                            "o": { "a": 0, "k": 100, "ix": 5 }
                        },
                        {
                            "ty": "tr",
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "p": { "a": 0, "k": [-284, 92], "ix": 2 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "o": { "a": 0, "k": 100, "ix": 7 }
                        }
                    ]
                }
            ],
            "ind": 3
        },
        {
            "ty": 4,
            "nm": "Dot1",
            "sr": 1,
            "st": 0,
            "op": 360,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [-284, 92, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [50, 50],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [75, 75],
                            "t": 14
                        },
                        { "s": [50, 50], "t": 30 }
                    ],
                    "ix": 6
                },
                "sk": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [782, 540],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [782, 500],
                            "t": 14
                        },
                        { "s": [782, 540], "t": 30 }
                    ],
                    "ix": 2
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [25],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.333, "y": 0 },
                            "i": { "x": 0.667, "y": 1 },
                            "s": [100],
                            "t": 14
                        },
                        { "s": [25], "t": 30 }
                    ],
                    "ix": 11
                }
            },
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Ellipse 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 3,
                    "it": [
                        {
                            "ty": "el",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Ellipse",
                            "nm": "Ellipse Path 1",
                            "d": 1,
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "s": { "a": 0, "k": [120, 120], "ix": 2 }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": { "a": 0, "k": [0.0902, 0.6784, 0.5255], "ix": 4 },
                            "r": 1,
                            "o": { "a": 0, "k": 100, "ix": 5 }
                        },
                        {
                            "ty": "tr",
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "p": { "a": 0, "k": [-284, 92], "ix": 2 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "o": { "a": 0, "k": 100, "ix": 7 }
                        }
                    ]
                }
            ],
            "ind": 4
        }
    ],
    "v": "5.7.0",
    "fr": 60,
    "op": 81,
    "ip": 0,
    "assets": []
}
